import { renderSidebar } from '../shared/sidebar';
import { applySidebarPermissions } from '../componants/sidebar';

// ============================================
// ADN PAGE - Vases d'Honneur
// ============================================

const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzv34TCKiDriWh5hHmMxH18WNNg-FwlNyO3GIRQU7PtqKM0seT70cA4g4IpIXoAlYutyQ/exec';
const SESSION_FALLBACK_TTL_MS = 6 * 60 * 60 * 1000;

// ============================================
// IMMEDIATE AUTH CHECK (RUNS BEFORE DOM READY)
// ============================================
(function immediateAuthCheck() {
    try {
        const user = getStoredUser();
        const session = getStoredSession();

        // Check if user is logged in
        if (!user || !user.email || !hasValidSession(session)) {
            console.warn('[SÉCURITÉ] Accès refusé: Utilisateur non connecté. Redirection vers login...');
            clearStoredAuth();
            window.location.replace('../login/login.html');
            throw new Error('AUTH_REDIRECT');
        }

        // Check if user has ADN department access
        const department = (user.departement || '').toUpperCase();
        const role = (user.role || '').toUpperCase();

        if (department !== 'ADN' && role !== 'ADN') {
            console.warn('[SÉCURITÉ] Accès refusé: Département ADN requis. Redirection vers dashboard...');
            window.location.replace('../dashboard/dashboard.html');
            throw new Error('DEPT_REDIRECT');
        }

        renderSidebar('adn');
        applySidebarPermissions(user);

        console.log('[SÉCURITÉ] Utilisateur ADN authentifié:', user.email);
    } catch (e) {
        if (e.message !== 'AUTH_REDIRECT' && e.message !== 'DEPT_REDIRECT') {
            console.error('[SÉCURITÉ] Erreur de vérification auth:', e);
            window.location.replace('../login/login.html');
        }
    }
})();

// ============================================
// TOAST NOTIFICATION SYSTEM
// ============================================

const Toast = {
    show: function (message, type = 'info', duration = 5000) {
        const container = document.getElementById('toast-container');
        if (!container) {
            console.warn('Toast container not found');
            return;
        }

        const toast = document.createElement('div');
        toast.className = `toast ${type}`;
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'assertive');

        const icons = {
            success: 'check-circle',
            error: 'exclamation-circle',
            warning: 'exclamation-triangle',
            info: 'info-circle'
        };

        toast.innerHTML = `
      <div class="toast-icon">
        <i class="fa-solid fa-${icons[type]}" aria-hidden="true"></i>
      </div>
      <div class="toast-content">
        <p class="toast-message"></p>
      </div>
      <button class="toast-close" aria-label="Fermer la notification">
        <i class="fa-solid fa-times"></i>
      </button>
    `;
        toast.querySelector('.toast-message').textContent = String(message || '');

        container.appendChild(toast);

        const timeout = setTimeout(() => this.dismiss(toast), duration);

        toast.querySelector('.toast-close').addEventListener('click', () => {
            clearTimeout(timeout);
            this.dismiss(toast);
        });

        return toast;
    },

    dismiss: function (toast) {
        toast.style.animation = 'slideOutRight 0.3s ease-out forwards';
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 300);
    },

    success: function (message, duration) { return this.show(message, 'success', duration); },
    error: function (message, duration) { return this.show(message, 'error', duration); },
    warning: function (message, duration) { return this.show(message, 'warning', duration); },
    info: function (message, duration) { return this.show(message, 'info', duration); }
};

window.Toast = Toast;

function getStoredUser() {
    try { return JSON.parse(localStorage.getItem('__vhb_user') || 'null'); }
    catch (_) { return null; }
}

function getStoredSession() {
    try { return JSON.parse(localStorage.getItem('__vhb_session') || 'null'); }
    catch (_) { return null; }
}

function getSessionToken() {
    const sess = getStoredSession();
    if (!sess || !sess.token) return '';
    if (sess.expires_at) {
        const ts = typeof sess.expires_at === 'string' ? Date.parse(sess.expires_at) : Number(sess.expires_at);
        if (!Number.isNaN(ts) && ts <= Date.now()) return '';
    }
    return sess.token;
}

function h(str) {
    return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function loadPendingActions() {
    try { pendingActions = JSON.parse(localStorage.getItem(PENDING_KEY) || '[]'); }
    catch (_) { pendingActions = []; }
}

function savePendingActions() {
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(pendingActions)); }
    catch (_) { }
}

function addPendingAction(action) {
    pendingActions.push(action);
    savePendingActions();
    renderPendingActions();
}

function removePendingAction(id) {
    pendingActions = pendingActions.filter(a => a.id !== id);
    savePendingActions();
    renderPendingActions();
}

function renderPendingActions() {
    const list = document.getElementById('pendingList');
    const countLabel = document.getElementById('pendingCountLabel');
    if (!list) return;
    list.innerHTML = '';
    if (!pendingActions || pendingActions.length === 0) {
        list.innerHTML = '<li style="color:var(--gray-500);text-align:center;padding:0.75rem;">Aucune confirmation en attente.</li>';
        if (countLabel) countLabel.textContent = '0 en attente';
        return;
    }
    if (countLabel) countLabel.textContent = `${pendingActions.length} en attente`;

    pendingActions.forEach(action => {
        const li = document.createElement('li');
        const recipients = action.targets?.length || 0;
        const title = `${h(action.type)} ${recipients > 1 ? `(${recipients} contacts)` : h(action.targets?.[0]?.name || '')}`;
        const msg = action.message ? h(action.message.substring(0, 140)) : h(action.note || '');
        li.className = 'card-soft';
        li.style.padding = '0.9rem';
        li.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:0.6rem;flex-wrap:wrap;">
          <div>
            <div style="font-weight:600;">${title}</div>
            <div style="color:var(--gray-600);font-size:0.9rem;">${msg || 'Pas de message'}</div>
            <div style="color:var(--gray-500);font-size:0.85rem;margin-top:0.25rem;">
              ${new Date(action.createdAt).toLocaleString('fr-FR')}
            </div>
          </div>
          <div style="display:flex;gap:0.4rem;">
            <button class="btn-primary btn-small" data-id="${action.id}">Confirmer</button>
            <button class="btn-secondary btn-small" data-id="${action.id}" data-cancel="1">Annuler</button>
          </div>
        </div>
      `;
        list.appendChild(li);
    });

    list.querySelectorAll('button[data-id]').forEach(btn => {
        btn.addEventListener('click', async () => {
            const id = btn.dataset.id;
            const isCancel = btn.dataset.cancel === '1';
            const action = pendingActions.find(a => a.id === id);
            if (!action) return;
            if (isCancel) {
                removePendingAction(id);
                Toast.info('Action annulée');
                return;
            }
            btn.disabled = true;
            btn.textContent = '...';
            try {
                const results = [];
                for (const target of action.targets || []) {
                    const note = action.message ? `SMS: ${personalizeMessage(action.message, target.name).substring(0, 140)}` : (action.note || '');
                    const success = await logActivityToBackend(target.name || target.phone || 'Contact', action.type, note);
                    results.push(!!success);
                }
                if (results.every(Boolean)) {
                    Toast.success('Action confirmée et journalisée');
                    removePendingAction(id);
                } else {
                    Toast.error('Erreur lors de la confirmation (au moins un contact non journalisé)');
                    btn.disabled = false;
                    btn.textContent = 'Confirmer';
                }
            } catch (err) {
                console.error('❌ Confirmation error', err);
                Toast.error('Erreur lors de la confirmation');
                btn.disabled = false;
                btn.textContent = 'Confirmer';
            }
        });
    });
}

function hasValidSession(session) {
    if (!session || !session.token) return false;
    if (session.expires_at) {
        const ts = typeof session.expires_at === 'string' ? Date.parse(session.expires_at) : Number(session.expires_at);
        if (!Number.isNaN(ts)) {
            return ts > Date.now();
        }
    }
    return true;
}

function clearStoredAuth() {
    try {
        localStorage.removeItem('__vhb_session');
        localStorage.removeItem('__vhb_user');
        localStorage.removeItem('__login_id');
    } catch (_) { }
}

function redirectToLogin() {
    location.replace('../login/login.html');
}

// ============================================
// DATA FETCHING
// ============================================

async function fetchContactData() {
    const user = getStoredUser();
    const role = String(user?.role || '').toUpperCase();
    const dept = String(user?.departement || '').toUpperCase();
    const isResponsable = role === 'RESPONSABLE';

    const callApi = async (payload) => {
        const token = getSessionToken();
        if (!token) throw new Error('Session expirée. Merci de vous reconnecter.');
        const response = await fetch(SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' }, // pas de préflight CORS
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data.ok) {
            throw new Error(data.error || 'Erreur lors de la récupération des données');
        }
        return data.rows || [];
    };

    try {
        // Responsables: liste complète. Membres ADN: liste scindée (28 jours, read-only)
        const payload = isResponsable
            ? { action: 'list', session_token: getSessionToken() }
            : { action: 'list', scope: 'adn', session_token: getSessionToken() };
        const rows = await callApi(payload);
        console.log('✅ Data loaded:', rows.length, isResponsable ? '(full)' : '(scoped ADN)');
        return { rows, isDemo: false };
    } catch (error) {
        console.warn('❌ Fetch error (primary):', error);
        const errMsg = (error?.message || '').toLowerCase();
        const roleBlocked = errMsg.includes('insuffisant') || errMsg.includes('unauthorized') || errMsg.includes('forbidden');

        if (!roleBlocked) {
            Toast.warning(`⚠️ API inaccessible. Affichage des données de démonstration.`, 5000);
        } else {
            Toast.info('Mode démo: accès restreint aux dernières 4 semaines.', 4000);
        }
        return { rows: buildDemoRows(), isDemo: true };
    }
}

// ============================================
// RENDER FUNCTIONS
// ============================================

// State
let allRows = [];
let filterState = {
    search: '',
    time: '30', // days
    status: ['NEW', 'PENDING']
};
let bulkRows = [];
let bulkSelected = new Set();
const bulkStatsEls = {
    period: null,
    total: null,
    selected: null,
    msgMeta: null,
    msgPreview: null,
    sendBtn: null
};
let smsSeparatorMode = 'auto'; // auto | android | ios

const PENDING_KEY = '__vhb_pending_actions';
let pendingActions = [];

function filterRecentRows(rows, days = 28) {
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - days);
    return (rows || []).filter(r => {
        const d = new Date(r.date);
        return !Number.isNaN(d.getTime()) && d >= cutoff;
    });
}

function buildDemoRows() {
    const today = new Date();
    const daysAgo = (n) => {
        const d = new Date(today);
        d.setDate(d.getDate() - n);
        return d.toISOString().slice(0, 10);
    };
    return [
        { date: daysAgo(3), name: 'Contact ADN 1', phone: '0102030405', district: 'Quartier A', gender: 'F', status: 'NOUVEAU' },
        { date: daysAgo(9), name: 'Contact ADN 2', phone: '0607080910', district: 'Quartier B', gender: 'M', status: 'NOUVEAU' },
        { date: daysAgo(14), name: 'Contact ADN 3', phone: '0504030201', district: 'Quartier C', gender: 'F', status: 'PENDING' },
        { date: daysAgo(20), name: 'Contact ADN 4', phone: '0706050403', district: 'Quartier D', gender: 'M', status: 'PENDING' },
        { date: daysAgo(26), name: 'Contact ADN 5', phone: '0101010101', district: 'Quartier E', gender: 'F', status: 'PENDING' }
    ];
}

function buildSmsUri(recipients, body) {
    const unique = Array.from(new Set((recipients || []).filter(Boolean)));
    const isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent || '');
    const isAndroid = /android/i.test(navigator.userAgent || '');
    const sep = smsSeparatorMode === 'auto'
        ? (isiOS ? ',' : (isAndroid ? ';' : ','))
        : (smsSeparatorMode === 'android' ? ';' : ',');
    const nums = unique.join(sep);
    if (!nums) return '';
    const hasBody = body && body.length > 0;
    // iOS attend &body, Android accepte ?body
    const bodyPart = hasBody ? (isiOS ? `&body=${encodeURIComponent(body)}` : `?body=${encodeURIComponent(body)}`) : '';
    return `sms:${nums}${bodyPart}`;
}

function renderContactList(rows) {
    if (rows) allRows = rows;

    const container = document.getElementById('contactList');
    if (!container) return;

    container.innerHTML = '';

    // --- ADVANCED FILTERING LOGIC ---
    let displayRows = allRows;

    // 1. Search Filter (Name or Phone)
    if (filterState.search) {
        const term = filterState.search.toLowerCase();
        displayRows = displayRows.filter(r =>
            (r.name && r.name.toLowerCase().includes(term)) ||
            (r.phone && r.phone.includes(term))
        );
    }

    // 2. Time Filter
    if (filterState.time !== 'all') {
        const days = parseInt(filterState.time);
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setDate(now.getDate() - days);
        displayRows = displayRows.filter(r => new Date(r.date) >= cutoff);
    }

    // 3. Status Filter (Simulated)
    // New < 7 days; Pending > 7 days; Done = never (unless we have data)
    displayRows = displayRows.filter(r => {
        const d = new Date(r.date);
        const ageDays = (new Date() - d) / (1000 * 60 * 60 * 24);

        // Determine status
        let status = 'PENDING';
        if (ageDays < 7) status = 'NEW';
        // if (r.status === 'DONE') status = 'DONE'; // Future real logic

        return filterState.status.includes(status);
    });

    // Sort by date desc
    displayRows.sort((a, b) => new Date(b.date) - new Date(a.date));

    if (displayRows.length === 0) {
        container.innerHTML = '<li class="empty-state">Aucun contact trouvé avec ces critères.</li>';
        document.getElementById('statContacts').textContent = 0;
        return;
    }

    displayRows.forEach(row => {
        const li = document.createElement('li');

        const d = new Date(row.date);
        const isNew = (new Date() - d) < (7 * 24 * 60 * 60 * 1000);
        li.className = isNew ? 'adn-item status-new' : 'adn-item';

        const dateStr = d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
        const initials = (row.name || '').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();

        li.innerHTML = `
      <div class="adn-header">
        <div class="adn-avatar">${initials}</div>
        <div class="adn-info">
            <h4>${h(row.name)}</h4>
            <div class="adn-badges">
                ${isNew ? '<span class="status-badge new">Nouveau</span>' : ''}
            </div>
        </div>
        <button class="btn-action btn-detail" onclick="openDetailModal('${row.name.replace(/'/g, "\\'")}')" title="Voir fiche">
            <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="adn-details">
        <div class="adn-detail-row">
            <i class="fa-solid fa-calendar-day"></i> 
            <span>${dateStr}</span>
        </div>
        <div class="adn-detail-row">
            <i class="fa-solid fa-map-marker-alt"></i> 
            <span>${h(row.district || 'Non précisé')}</span>
        </div>
        <div class="adn-detail-row">
            <i class="fa-solid fa-phone"></i> 
            <span>${h(row.phone)}</span>
        </div>
      </div>

      <div class="adn-actions">
        <button class="btn-action btn-sms" onclick="triggerSMS('${row.phone}', '${row.name.replace(/'/g, "\\'")}')" title="SMS">
          <i class="fa-solid fa-comment-sms"></i> SMS
        </button>
        <button class="btn-action btn-call" onclick="triggerCall('${row.phone}', '${row.name.replace(/'/g, "\\'")}')" title="Appel">
          <i class="fa-solid fa-phone"></i> Appel
        </button>
        <button class="btn-action btn-note" onclick="openNoteModal('${row.name.replace(/'/g, "\\'")}')" title="Note">
          <i class="fa-solid fa-note-sticky"></i> Note
        </button>
      </div>
    `;
        container.appendChild(li);
    });

    // Update stat
    document.getElementById('statContacts').textContent = displayRows.length;
}

// --- FILTER EVENT HANDLERS ---

// Search Input
const searchInput = document.getElementById('searchInput');
if (searchInput) {
    searchInput.addEventListener('input', (e) => {
        filterState.search = e.target.value;
        renderContactList();
    });
}

// Filter Dropdown Toggle
const filterToggleBtn = document.getElementById('filterToggleBtn');
if (filterToggleBtn) {
    filterToggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const menu = document.getElementById('filterMenu');
        menu.classList.toggle('active');
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
        const menu = document.getElementById('filterMenu');
        if (menu && menu.classList.contains('active') && !menu.contains(e.target) && e.target !== filterToggleBtn) {
            menu.classList.remove('active');
        }
    });

    // Prevent closing when clicking inside menu
    document.getElementById('filterMenu').addEventListener('click', (e) => {
        e.stopPropagation();
    });
}

// Apply Filters
const applyFiltersBtn = document.getElementById('applyFilters');
if (applyFiltersBtn) {
    applyFiltersBtn.addEventListener('click', () => {
        // Read Time
        filterState.time = document.getElementById('filterTime').value;

        // Read Status checkboxes
        const checkboxes = document.querySelectorAll('#filterMenu input[type="checkbox"]:checked');
        filterState.status = Array.from(checkboxes).map(cb => cb.value);

        // Apply
        renderContactList();
        document.getElementById('filterMenu').classList.remove('active');
        Toast.info('Filtres appliqués');
    });
}

// ============================================
// BULK MESSAGING
// ============================================

function personalizeMessage(template, fullName) {
    const firstName = (fullName || '').split(' ')[0] || '';
    return template.replace(/{{prenom}}/gi, firstName);
}

function formatPeriodLabel(fromVal, toVal) {
    if (!fromVal && !toVal) return 'Période : --';
    if (fromVal && toVal) return `Période : ${fromVal} → ${toVal}`;
    if (fromVal) return `Depuis le ${fromVal}`;
    return `Jusqu’au ${toVal}`;
}

function updateBulkStats({ fromVal = '', toVal = '' } = {}) {
    const total = bulkRows.length;
    const selected = bulkSelected.size;
    if (bulkStatsEls.period) bulkStatsEls.period.textContent = formatPeriodLabel(fromVal, toVal);
    if (bulkStatsEls.total) bulkStatsEls.total.textContent = `${total} contact${total > 1 ? 's' : ''} filtré${total > 1 ? 's' : ''}`;
    if (bulkStatsEls.selected) bulkStatsEls.selected.textContent = `${selected} sélectionné${selected > 1 ? 's' : ''}`;
    if (bulkStatsEls.sendBtn) {
        bulkStatsEls.sendBtn.disabled = selected === 0;
        bulkStatsEls.sendBtn.innerHTML = `<i class="fa-solid fa-paper-plane"></i> Envoyer${selected ? ` (${selected})` : ' aux sélectionnés'}`;
    }
}

function updateBulkMessagePreview(template, sampleName) {
    const msg = personalizeMessage(template || '', sampleName || 'Invité');
    const len = msg.length;
    if (bulkStatsEls.msgMeta) bulkStatsEls.msgMeta.textContent = `${len} caractère${len > 1 ? 's' : ''}`;
    if (bulkStatsEls.msgPreview) bulkStatsEls.msgPreview.textContent = msg || 'Votre message apparaîtra ici.';
}

function renderBulkList(rows) {
    const tbody = document.getElementById('bulkList');
    const selectAll = document.getElementById('bulkSelectAll');
    const sendBtn = document.getElementById('bulkSend');
    if (!tbody) return;

    tbody.innerHTML = '';
    bulkRows = rows || bulkRows;
    if (!bulkRows || bulkRows.length === 0) {
        tbody.innerHTML = '<tr><td colspan="4" style="text-align:center;color:var(--gray-500);padding:12px;">Aucun contact pour cette période.</td></tr>';
        sendBtn && (sendBtn.disabled = true);
        if (selectAll) selectAll.checked = false;
        bulkSelected = new Set();
        updateBulkStats();
        return;
    }

    bulkRows.forEach((row, idx) => {
        const d = new Date(row.date);
        const initials = (row.name || '').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
        const tr = document.createElement('tr');
        tr.innerHTML = `
      <td style="text-align:center;"><input type="checkbox" data-idx="${idx}" class="bulk-check"></td>
      <td>
        <div style="display:flex; align-items:center; gap:0.75rem;">
            <div class="avatar-small">${initials}</div>
            <div class="contact-name">${h(row.name || 'Inconnu')}</div>
        </div>
      </td>
      <td class="contact-meta">${h(row.phone || '')}</td>
      <td class="contact-meta">${d.toLocaleDateString('fr-FR')}</td>
    `;
        tbody.appendChild(tr);
    });

    const checkboxes = tbody.querySelectorAll('.bulk-check');
    checkboxes.forEach(cb => {
        cb.addEventListener('change', () => {
            const idx = parseInt(cb.dataset.idx, 10);
            if (cb.checked) bulkSelected.add(idx); else bulkSelected.delete(idx);
            if (selectAll) selectAll.checked = bulkSelected.size === bulkRows.length;
            updateBulkStats();
        });
    });

    if (selectAll) {
        selectAll.checked = false;
        selectAll.onchange = () => {
            const on = selectAll.checked;
            bulkSelected = new Set();
            checkboxes.forEach(cb => {
                cb.checked = on;
                if (on) bulkSelected.add(parseInt(cb.dataset.idx, 10));
            });
            updateBulkStats();
        };
    }
    updateBulkStats();
}

function applyBulkFilter() {
    if (!allRows || allRows.length === 0) return;
    const fromInput = document.getElementById('bulkFrom');
    const toInput = document.getElementById('bulkTo');
    const from = fromInput?.value ? new Date(fromInput.value) : null;
    const to = toInput?.value ? new Date(toInput.value) : null;
    const filtered = allRows.filter(r => {
        const d = new Date(r.date);
        if (from && d < from) return false;
        if (to) {
            const end = new Date(to);
            end.setHours(23, 59, 59, 999);
            if (d > end) return false;
        }
        return true;
    });
    bulkSelected = new Set();
    renderBulkList(filtered);
    updateBulkStats({ fromVal: fromInput?.value || '', toVal: toInput?.value || '' });
}

function initBulkMessaging() {
    const fromInput = document.getElementById('bulkFrom');
    const toInput = document.getElementById('bulkTo');
    const applyBtn = document.getElementById('bulkApply');
    const sendBtn = document.getElementById('bulkSend');
    const messageArea = document.getElementById('bulkMessage');
    const presetButtons = document.querySelectorAll('.chip[data-preset]');
    const sepSelect = document.getElementById('bulkSeparator');
    if (!fromInput || !toInput || !applyBtn || !sendBtn || !messageArea) return;

    bulkStatsEls.period = document.getElementById('bulkPeriodLabel');
    bulkStatsEls.total = document.getElementById('bulkCountLabel');
    bulkStatsEls.selected = document.getElementById('bulkSelectedLabel');
    bulkStatsEls.msgMeta = document.getElementById('bulkMessageMeta');
    bulkStatsEls.msgPreview = document.getElementById('bulkMessagePreview');
    bulkStatsEls.sendBtn = sendBtn;

    const today = new Date();
    const start = new Date();
    start.setDate(today.getDate() - 30);
    fromInput.value = fromInput.value || start.toISOString().substring(0, 10);
    toInput.value = toInput.value || today.toISOString().substring(0, 10);
    updateBulkStats({ fromVal: fromInput.value, toVal: toInput.value });
    updateBulkMessagePreview(messageArea.value, 'Invité');

    applyBtn.addEventListener('click', () => {
        applyBulkFilter();
        Toast.info('Période filtrée pour l’envoi multiple');
    });

    presetButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const days = parseInt(btn.dataset.preset, 10);
            const from = new Date();
            from.setDate(from.getDate() - days);
            fromInput.value = from.toISOString().substring(0, 10);
            toInput.value = today.toISOString().substring(0, 10);
            applyBulkFilter();
            Toast.info(`Filtre appliqué: ${btn.textContent}`);
            presetButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
        });
    });

    if (sepSelect) {
        smsSeparatorMode = sepSelect.value;
        sepSelect.addEventListener('change', () => {
            smsSeparatorMode = sepSelect.value;
            Toast.info(`Mode séparateur: ${smsSeparatorMode}`);
        });
    }

    messageArea.addEventListener('input', () => {
        const sampleName = bulkSelected.size > 0 && bulkRows[Array.from(bulkSelected)[0]] ? bulkRows[Array.from(bulkSelected)[0]].name : 'Invité';
        updateBulkMessagePreview(messageArea.value, sampleName);
    });

    sendBtn.addEventListener('click', async () => {
        if (bulkSelected.size === 0) return Toast.warning('Sélectionnez au moins un contact');
        const template = messageArea.value.trim();
        if (!template) return Toast.warning('Renseignez le message à envoyer');

        const selectedList = Array.from(bulkSelected).map(idx => bulkRows[idx]).filter(Boolean);
        const recipients = selectedList
            .map(r => (r.phone || '').replace(/[^0-9+]/g, ''))
            .filter(Boolean);
        if (recipients.length === 0) return Toast.warning('Aucun numéro valide sélectionné');

        const body = personalizeMessage(template, selectedList[0]?.name || '');
        const smsUri = buildSmsUri(recipients, body);
        window.open(smsUri, '_blank');

        addPendingAction({
            id: Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'SMS',
            targets: selectedList.map(r => ({ name: r.name, phone: r.phone })),
            note: '',
            message: template,
            createdAt: new Date().toISOString(),
            bulk: true
        });
        Toast.success(`${recipients.length} contact(s) ajoutés à l’envoi. Confirmez après envoi dans la liste en attente.`);
    });

    // Initial render
    applyBulkFilter();
}

// Reset Filters
const resetFiltersBtn = document.getElementById('resetFilters');
if (resetFiltersBtn) {
    resetFiltersBtn.addEventListener('click', () => {
        // Reset State
        filterState.time = '30';
        filterState.status = ['NEW', 'PENDING'];
        filterState.search = '';

        // Reset UI
        document.getElementById('filterTime').value = '30';
        document.getElementById('searchInput').value = '';
        document.querySelectorAll('#filterMenu input[type="checkbox"]').forEach(cb => {
            cb.checked = ['NEW', 'PENDING'].includes(cb.value);
        });

        renderContactList();
        document.getElementById('filterMenu').classList.remove('active');
        Toast.info('Filtres réinitialisés');
    });
}



// ============================================
// ACTION HANDLERS
// ============================================

// ============================================
// GLOBAL FUNCTION EXPOSURE (Must be at top level for onclick handlers)
// ============================================

window.triggerSMS = function triggerSMS(phone, name) {
    openActionModal('SMS', phone, name);
};

window.triggerCall = function triggerCall(phone, name) {
    openActionModal('CALL', phone, name || phone);
};

window.currentNoteTarget = '';

window.openNoteModal = function openNoteModal(targetName) {
    window.currentNoteTarget = targetName;
    document.getElementById('noteTargetName').value = targetName;
    document.getElementById('noteContent').value = '';
    document.getElementById('noteModal').classList.add('active');
    setTimeout(() => document.getElementById('noteContent').focus(), 100);
};

window.closeNoteModal = function closeNoteModal() {
    document.getElementById('noteModal').classList.remove('active');
    window.currentNoteTarget = '';
};

window.submitNote = async function submitNote() {
    console.log('🚀 submitNote CALLED');

    const content = document.getElementById('noteContent').value;
    const target = window.currentNoteTarget;

    console.log('📝 Content:', content);
    console.log('👤 Target:', target);

    if (!content.trim()) {
        console.log('⚠️ Note is empty');
        return Toast.warning('La note est vide');
    }

    console.log('📤 Calling logActivityToBackend...');

    try {
        const success = await logActivityToBackend(target, 'NOTE', content);
        console.log('📥 Backend response success:', success);

        if (success) {
            Toast.success('Note enregistrée');
            window.closeNoteModal();
        } else {
            Toast.error('Erreur lors de l\'enregistrement');
        }
    } catch (err) {
        console.error('❌ Error in submitNote:', err);
        Toast.error('Erreur: ' + err.message);
    }
};

// ===== Confirmation SMS/Appel =====
let pendingAction = null;

function defaultSmsMessage(name) {
    const firstName = (name || '').split(' ')[0] || '';
    return `Bonjour ${firstName}, nous sommes très heureux de vous avoir accueilli à Vases d'Honneur (Rehoboth). Nous espérons que vous avez été béni(e). Bon dimanche !`;
}

window.openActionModal = function openActionModal(type, phone, name) {
    if (!phone) return Toast.error('Numéro de téléphone manquant');
    pendingAction = { type, phone, name };
    const title = type === 'CALL' ? 'Confirmer l\'appel' : 'Confirmer l\'envoi du SMS';
    document.getElementById('actionTitle').textContent = title;
    document.getElementById('actionTargetLabel').textContent = `${type === 'CALL' ? 'Appel' : 'SMS'} vers ${name || phone}`;
    document.getElementById('actionNote').value = '';
    document.getElementById('actionModal').classList.add('active');
};

window.closeActionModal = function closeActionModal() {
    pendingAction = null;
    document.getElementById('actionModal').classList.remove('active');
};

window.confirmAction = async function confirmAction() {
    if (!pendingAction) return closeActionModal();
    const { type, phone, name } = pendingAction;
    const note = document.getElementById('actionNote').value.trim();
    const cleanPhone = (phone || '').replace(/[^0-9+]/g, '');
    if (!cleanPhone) {
        Toast.error('Numéro invalide');
        return;
    }

    if (type === 'SMS') {
        const message = defaultSmsMessage(name);
        const uri = buildSmsUri([cleanPhone], message);
        window.open(uri, '_blank');
        addPendingAction({
            id: Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'SMS',
            targets: [{ name: name || phone, phone: cleanPhone }],
            note: note || '',
            message,
            createdAt: new Date().toISOString()
        });
        Toast.success('SMS ouvert, confirmez dans la liste en attente.');
    } else if (type === 'CALL') {
        window.location.href = `tel:${cleanPhone}`;
        addPendingAction({
            id: Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'CALL',
            targets: [{ name: name || phone, phone: cleanPhone }],
            note: note || 'Appel à confirmer',
            createdAt: new Date().toISOString()
        });
        Toast.success('Appel lancé, confirmez dans la liste en attente.');
    }
    closeActionModal();
};

// ============================================
// TIMELINE RENDERER
// ============================================

window.renderTimeline = function renderTimeline(history, container) {
    container.innerHTML = '';

    history.forEach(item => {
        const div = document.createElement('div');

        // Type mapping for styling
        let typeClass = 'note';
        let icon = 'fa-note-sticky';
        let typeLabel = 'NOTE';

        if (item.type === 'SMS') {
            typeClass = 'sms';
            icon = 'fa-comment-sms';
            typeLabel = 'SMS';
        } else if (item.type === 'APPEL' || item.type === 'CALL') {
            typeClass = 'call';
            icon = 'fa-phone';
            typeLabel = 'APPEL';
        }

        div.className = `timeline-item ${typeClass}`;

        // Format date
        const dateAction = new Date(item.date_action || item.timestamp);
        const dateStr = dateAction.toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });

        div.innerHTML = `
            <div class="timeline-dot"><i class="fa-solid ${icon}"></i></div>
            <div class="timeline-content">
                <div class="timeline-meta">
                    <span class="timeline-type ${typeClass}">${typeLabel}</span>
                    <span class="timeline-date">${dateStr}</span>
                </div>
                <div class="timeline-text">${h(item.note || '(Aucun contenu)')}</div>
                <div class="timeline-staff">Par: ${h(item.staff || 'Inconnu')}</div>
            </div>
        `;
        container.appendChild(div);
    });
};

window.openDetailModal = async function openDetailModal(name) {
    const row = allRows.find(r => r.name === name);
    if (!row) return;

    // Open Modal
    const modal = document.getElementById('detailModal');
    modal.classList.add('active');

    // Render Static Info
    const d = new Date(row.date);
    const dateStr = d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

    document.getElementById('detailInfo').innerHTML = `
        <div class="adn-header" style="margin-bottom: 1.5rem">
            <div class="adn-avatar" style="width:64px;height:64px;font-size:1.5rem">
                ${h(name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase())}
            </div>
            <div>
                <h3 style="margin:0;font-size:1.25rem">${h(name)}</h3>
                <div style="color:var(--gray-500);font-size:0.9rem">${h(row.phone)}</div>
                <div style="margin-top:0.25rem"><span class="status-badge new">Nouveau</span></div>
            </div>
        </div>
        <div class="grid-two" style="margin-bottom:1.5rem; gap:1rem">
            <div class="info-item">
                <label style="display:block;color:var(--gray-500);font-size:0.8rem">Date d'arrivée</label>
                <div style="font-weight:500">${dateStr}</div>
            </div>
            <div class="info-item">
                <label style="display:block;color:var(--gray-500);font-size:0.8rem">Quartier</label>
                <div style="font-weight:500">${h(row.district || '-')}</div>
            </div>
            <div class="info-item">
                <label style="display:block;color:var(--gray-500);font-size:0.8rem">Tranche d'âge</label>
                <div style="font-weight:500">${h(row.age_range || '-')}</div>
            </div>
             <div class="info-item">
                <label style="display:block;color:var(--gray-500);font-size:0.8rem">Situation</label>
                <div style="font-weight:500">${h(row.marital_status || '-')}</div>
            </div>
        </div>
    `;

    // Fetch History
    const timelineContainer = document.getElementById('detailTimeline');
    timelineContainer.innerHTML = '<div class="timeline-loading">Chargement de l\'historique...</div>';

    try {
        const token = getSessionToken();
        if (!token) throw new Error('Session expirée. Merci de vous reconnecter.');
        const payload = {
            action: 'get_contact_history',
            target_name: name,
            session_token: token
        };

        console.log('📜 Fetching history for:', name);
        console.log('📤 Payload:', JSON.stringify(payload));

        const response = await fetch(SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        console.log('📥 History response:', JSON.stringify(data));

        if (data.ok && data.history && data.history.length > 0) {
            window.renderTimeline(data.history, timelineContainer);
        } else if (data.ok) {
            timelineContainer.innerHTML = '<div style="color:var(--gray-500);font-style:italic">Aucune activité enregistrée pour ce contact.</div>';
        } else {
            console.error('❌ Backend error:', data.error);
            timelineContainer.innerHTML = '<div style="color:var(--danger)">Erreur: ' + (data.error || 'Inconnue') + '</div>';
        }
    } catch (e) {
        console.error('❌ Fetch error:', e);
        timelineContainer.innerHTML = '<div style="color:var(--danger)">Erreur de chargement: ' + e.message + '</div>';
    }
};

window.closeDetailModal = function closeDetailModal() {
    document.getElementById('detailModal').classList.remove('active');
};

async function logActivityToBackend(targetName, type, content) {
    const token = getSessionToken();
    if (!token) {
        redirectToLogin();
        return false;
    }

    const payload = {
        action: 'log_activity',
        target_name: targetName,
        action_type: type,
        note_content: content,
        date_action: new Date().toISOString(),
        session_token: token
    };

    try {
        console.log('📤 Sending to backend:', JSON.stringify(payload));
        const response = await fetch(SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify(payload)
        });
        const res = await response.json();
        console.log('📥 Backend response:', JSON.stringify(res));
        return !!(res && (res.ok || res.success));
    } catch (e) {
        console.error('❌ Log error', e);
        Toast.error('Erreur lors de l\'enregistrement');
        return false;
    }
}

// ============================================
// INIT
// ============================================

async function init() {
    const user = getStoredUser();

    if (!user || !user.email) {
        console.warn('User not authenticated');
        redirectToLogin();
        return;
    }

    // Check department access
    const department = (user.departement || '').toUpperCase();
    const role = (user.role || '').toUpperCase();
    const isResponsable = role === 'RESPONSABLE';

    if (department !== 'ADN' && role !== 'ADN') {
        Toast.error('Accès refusé: Section réservée au département ADN');
        setTimeout(() => location.replace('../dashboard/dashboard.html'), 2000);
        return;
    }

    console.log('✅ ADN access granted:', user.email);

    // Set year
    document.getElementById('year').textContent = new Date().getFullYear();

    // Set user info
    document.getElementById('userName').textContent = `${user.firstname || ''} ${user.lastname || ''}`.trim() || 'Utilisateur';
    document.getElementById('roleBadge').textContent = role;
    const avatar = document.getElementById('avatar');
    const initials = (user.firstname || user.lastname || 'VU').trim().slice(0, 2).toUpperCase();
    avatar.textContent = initials;

    // Logout button
    document.getElementById('btnLogout').addEventListener('click', () => {
        localStorage.removeItem('__vhb_session');
        localStorage.removeItem('__vhb_user');
        localStorage.removeItem('__login_id');
        location.replace('../login/login.html');
    });

    // Refresh button
    document.getElementById('refreshBtn').addEventListener('click', () => {
        location.reload();
    });

    // ========================================
    // SIDEBAR TOGGLE (Mobile)
    // ========================================
    const hamburgerBtn = document.getElementById('hamburgerBtn');
    const sidebarClose = document.getElementById('sidebarClose');
    const sidebarOverlay = document.getElementById('sidebarOverlay');
    const sidebar = document.querySelector('.sidebar');

    function openSidebar() {
        sidebar.classList.add('active');
        sidebarOverlay.classList.add('active');
        document.body.classList.add('sidebar-open');
        hamburgerBtn.setAttribute('aria-expanded', 'true');
    }

    function closeSidebar() {
        sidebar.classList.remove('active');
        sidebarOverlay.classList.remove('active');
        document.body.classList.remove('sidebar-open');
        hamburgerBtn.setAttribute('aria-expanded', 'false');
    }

    if (hamburgerBtn) {
        hamburgerBtn.addEventListener('click', openSidebar);
    }

    if (sidebarClose) {
        sidebarClose.addEventListener('click', closeSidebar);
    }

    if (sidebarOverlay) {
        sidebarOverlay.addEventListener('click', closeSidebar);
    }

    // Close sidebar on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sidebar.classList.contains('active')) {
            closeSidebar();
        }
    });

    // Close sidebar when clicking nav links
    document.querySelectorAll('.nav-item').forEach(link => {
        link.addEventListener('click', () => {
            if (window.innerWidth <= 992) {
                closeSidebar();
            }
        });
    });

    // Load data
    const dataResult = await fetchContactData();
    const rows = dataResult?.rows || [];
    const scopedRows = isResponsable ? rows : filterRecentRows(rows, 28);
    if (scopedRows && scopedRows.length > 0) {
        if (!isResponsable) {
            filterState.time = '28';
        }
        renderContactList(scopedRows);
        initBulkMessaging();
    }
    loadPendingActions();
    renderPendingActions();

    Toast.success('Bienvenue dans l\'espace ADN', 2000);
}

document.addEventListener('DOMContentLoaded', init);
